export function popupGallery() {

    const popupTrigger = $('.js-popup-gallery-btn'),
          popupClose = $('.js-popup-close-btn'),
          popupPrev = $('.js-popup-prev-btn'),
          popupNext = $('.js-popup-next-btn'),
          popupModal = $('.js-popup-gallery-modal');

    let id;

    popupTrigger.on('click', function(e){
        e.preventDefault();
        id = $(this).attr("data-post-id");
        openModal(id);
        popupPrev.hide()
        popupNext.hide()
        currentSlide(id)
    });

    popupClose.on('click', function (e) {
        e.preventDefault();
        id = $(this).attr("data-post-id");
        closeModal(id);
    });

    popupModal.on('click', function (e) {
        e.preventDefault();
        id = $(this).attr("data-post-id");
        closeModal(id);
    });

    popupPrev.on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        plusSlides(-1)
    });

    popupNext.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        plusSlides(1)
    });


    function openModal(id) {
        document.getElementById(`modal__${id}`).style.display = "block";
    }

    function closeModal(id) {
        document.getElementById(`modal__${id}`).style.display = "none";
    }

    let slideIndex = 1;

    function plusSlides(n) {
        showSlides(slideIndex += n);
    }

    function currentSlide(n) {
        showSlides(slideIndex = n);
    }

    function showSlides(n) {
        let i;
        const slides = document.getElementById(`modal__${id}`).getElementsByClassName(`js-popup-gallery-slides`);
        if (n > slides.length) {slideIndex = 1}
        if (n < 1) {slideIndex = slides.length}
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        if (slides.length > 1) {
            popupPrev.show()
            popupNext.show()
        }
        slides[slideIndex-1].style.display = "block";
    }

}
